import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { QuoteModalProvider } from "./context/QuoteModalContext";
import QuoteModal from "./components/feature/QuoteModal";
import ScrollToTop from "./components/feature/ScrollToTop";

function App() {
  // Gracefully hide any image that fails to load (e.g. legacy WordPress image
  // URLs that no longer exist) so broken-image icons never show, and collapse
  // their grey placeholder boxes. Temporary, remove once images are restored.
  useEffect(() => {
    const hideBroken = (e: Event) => {
      const el = e.target as HTMLElement;
      if (el && el.tagName === 'IMG') {
        (el as HTMLImageElement).style.visibility = 'hidden';
        const p = el.parentElement;
        if (p && typeof p.className === 'string' && /bg-gray/.test(p.className)) {
          (p as HTMLElement).style.display = 'none';
        }
      }
    };
    document.addEventListener('error', hideBroken, true);
    return () => document.removeEventListener('error', hideBroken, true);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <QuoteModalProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <ScrollToTop />
          <AppRoutes />
        </BrowserRouter>
        <QuoteModal />
      </QuoteModalProvider>
    </I18nextProvider>
  );
}

export default App;
